import PropTypes from "prop-types";

import BasicRender from "./BasicRender";

/**
 *
 * Component renders a list of editable templates of type PositionPlan
 */
const PlanPositioningRender = ({
  planPositioningTemplate,
  onRemove,
  isEditable,
}) => {
  return (
    <BasicRender
      datasetTemplate={planPositioningTemplate}
      onRemove={onRemove}
      isEditable={isEditable}
    />
  );
};

PlanPositioningRender.propTypes = {
  planPositioningTemplate: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  isEditable: PropTypes.bool,
};

export default PlanPositioningRender;
